export default {
    _makeGridARIACompliant: function() {
        //labels and describedby need copied over to the actually focusable elements
        //labels must be removed from the parent div so that they do not get read by jaws multiple times
        //described by can't be removed because the loading bar is manipulating it. Leaving it harms nothing
        const adjust = this.table.add(this.footer.add(this.thead).parent("table"));
        this._label = this.wrapper.attr("aria-label") || this._label;
        this._labelledby = this.wrapper.attr("aria-labelledby") || this._labelledby;
        adjust
            .attr("aria-label", this._label)
            .attr("aria-labelledby", this._labelledby)
            .attr("aria-describedby", this.wrapper.attr("aria-describedby"));
        this.wrapper.filter("div:not([tabindex])").removeAttr("aria-label").removeAttr("aria-labelledby");
    }
}
